/* BaristaYOU – RB Crafts custom lead time override. Draft theme only. */
(function () {
  'use strict';

  var CUSTOM_HANDLES = {
    'la-marzocco-linea-mini-r-salbeigruen-ral-6021-rb-crafts': true,
    'la-marzocco-linea-mini-r-rosa-rb-crafts-custom': true
  };

  function deliveryLabel() {
    var lang = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    if (lang === 'en') return 'Delivery time 4–5 weeks from order';
    if (lang === 'fr') return 'Délai de livraison : 4–5 semaines à compter de la commande';
    if (lang === 'es') return 'Plazo de entrega: 4–5 semanas desde el pedido';
    if (lang === 'nl') return 'Levertijd: 4–5 weken vanaf bestelling';
    return 'Lieferzeit 4–5 Wochen ab Bestelleingang';
  }

  function applyRbCraftsDelivery() {
    var info = document.querySelector('product-info[data-product-handle]');
    if (!info) return;
    var handle = info.getAttribute('data-product-handle') || '';
    if (!CUSTOM_HANDLES[handle]) return;

    var delivery = info.querySelector('[data-by-delivery]');
    if (!delivery) return;

    var label = deliveryLabel();
    if (delivery.textContent.trim() !== label) delivery.textContent = label;
  }

  function init() {
    var info = document.querySelector('product-info[data-product-handle]');
    if (!info) return;
    var handle = info.getAttribute('data-product-handle') || '';
    if (!CUSTOM_HANDLES[handle]) return;

    applyRbCraftsDelivery();

    if (window.MutationObserver && info.dataset.byRbCraftsDeliveryWatch !== 'true') {
      info.dataset.byRbCraftsDeliveryWatch = 'true';
      new MutationObserver(function () {
        applyRbCraftsDelivery();
      }).observe(info, { childList: true, subtree: true, characterData: true });
    }

    setTimeout(applyRbCraftsDelivery, 100);
    setTimeout(applyRbCraftsDelivery, 400);
    setTimeout(applyRbCraftsDelivery, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
